import { render, staticRenderFns } from "./PurchasedProduct.vue?vue&type=template&id=17d1b8c3&scoped=true"
import script from "./PurchasedProduct.vue?vue&type=script&lang=js"
export * from "./PurchasedProduct.vue?vue&type=script&lang=js"
import style0 from "./PurchasedProduct.vue?vue&type=style&index=0&id=17d1b8c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d1b8c3",
  null
  
)

export default component.exports